<template>
  <div id="add__project__deliverable">
    <HeaderControlsAddProject :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate'  :namespace="namespace"/>
    <div class="container-fluid listing">
      <AddProjectDeliverableList :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" :removedDeliverableId="removedDeliverableId"  :namespace="namespace"/>
    </div>
  </div>
</template>
<script>
import AddProjectDeliverableList from "../components/deliverables/AddProjectDeliverableList";
import HeaderControlsAddProject from "../components/common/HeaderControlsAddProject";
import { mapGetters } from "vuex";

export default {
	props: ['removedDeliverableId'],
  data() {
    return {
    	namespace:"",
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: []
      },
      expandAll: !this.isMobile()
    }
  },
  computed: {
    ...mapGetters(["allCustomFields", 'allUsers']),
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    AddProjectDeliverableList,
    HeaderControlsAddProject
  },
  methods: {
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
};
</script>